import type { FormItem } from '../../../../../../api/types/expenseareas';

/** Общая проверка response_validation для publish и для снятия ошибок в билдере. */
export function computeKickoffResponseValidation(field: FormItem): {
    isValidResponseValidation: boolean;
} {
    const responseValidationSetting = field.settings.find((setting) => setting.type === 'response_validation');
    const selectedValidationType = responseValidationSetting?.options?.find((opt) => opt.selected);
    const selectedCondition = selectedValidationType?.options?.find((elem) => elem.selected);

    const isValue =
        'value' in (selectedCondition ?? {}) ? Boolean((selectedCondition as { value?: unknown })?.value) : true;
    const isPattern =
        'pattern' in (selectedCondition ?? {})
            ? Boolean((selectedCondition as { pattern?: unknown })?.pattern)
            : true;

    const hasMin = 'min' in (selectedCondition ?? {});
    const hasMax = 'max' in (selectedCondition ?? {});
    const cond = selectedCondition as Record<string, unknown> | undefined;

    /* Раньше для select_at_least проверяли только pattern — при min без pattern условие всегда падало. */
    const isMin =
        hasMin && !hasMax
            ? Boolean(
                  cond &&
                      (Boolean(cond.pattern) ||
                          (cond.min != null &&
                              cond.min !== '' &&
                              String(cond.min).trim() !== '' &&
                              Number(cond.min) > 0))
              )
            : true;

    const isValidResponseValidation = responseValidationSetting?.switchValue
        ? !!(selectedValidationType && selectedCondition && isValue && isPattern && isMin)
        : true;

    return { isValidResponseValidation };
}

/** Совпадает с логикой publish() для одного поля: можно снимать клиентскую ошибку. */
export function isKickoffFieldSatisfiedClientPublishRules(field: FormItem): boolean {
    const type = field.type;
    const { isValidResponseValidation } = computeKickoffResponseValidation(field);

    if (type === 'short-answer' || type === 'paragraph' || type === 'explanation-banner') {
        if (!field.label) return false;
        return isValidResponseValidation;
    }

    if (type === 'single-select' || type === 'multiple-choice' || type === 'dropdown') {
        if (!field.label) return false;
        if (!field?.options?.every((option) => option.value)) return false;

        if (
            field.settings.find((setting) => setting.type === 'rating-points')?.switchValue &&
            !field.settings
                .find((setting) => setting.type === 'question_category')
                ?.options?.some((option) => option.selected)
        ) {
            return false;
        }

        if (
            field.settings.find((setting) => setting.type === 'tender_brief')?.switchValue &&
            !field.settings.find((setting) => setting.type === 'tender_brief')?.options.some((elem) => elem.selected)
        ) {
            return false;
        }

        if (!isValidResponseValidation) return false;

        if (
            field.settings.find((setting) => setting.type === 'gate_1_filtering')?.switchValue &&
            !field.settings.find((setting) => setting.type === 'gate_1_filtering')?.options.some((elem) => elem.selected)
        ) {
            return false;
        }

        return true;
    }

    return true;
}
